<script>

	import OperationsSection from '../../ops/OperationsSection.svelte';
	import OperationsSectionContent from '../../ops/OperationsSectionContent.svelte';
	import SpecialtyMultipliers from '../SpecialtyMultipliers.svelte';
	import { treacheryInfo, treacheryValues } from '../../../modules.js';

	export let p;
	export let isPreview = false;
</script>

	<div class="treachery-board flex-div {isPreview ? 'track_preview' : ''}" >
		<img class="board-bg" src="./assets/board-tre.png" alt="treachery-board" />
		<div class="deck-label glow-label font-block">TREACHERY</div>

		<div class="info-container mission">
			<OperationsSection type="resupply" let:labelColor let:textColor>
					<OperationsSectionContent operations={treacheryInfo()} {labelColor} {textColor} />
			</OperationsSection>
		</div>
		<SpecialtyMultipliers {p} preview={isPreview} track="treachery" trackValues={treacheryValues()} verticalInvert topOffset={68} />
	</div>

<style lang="scss">
	.treachery-board {
		position: relative;
		width: fit-content;
		height: fit-content;
		font-size: calc(var(--height) / 25.0625); // Base 16px for sizing
		color: black;
	}
	img.board-bg {
		max-width: calc(var(--height) / 0.401); //1000px;
	}
	.glow-label {
		position: absolute;
		color: azure;
		text-shadow: 0 0 6px lightgrey;
	}
	.deck-label {
		font-size: calc(var(--height) / 16.708); //24px;
		top: 33.75%;
		left: 50%;
		transform: translate(-50%, 0);
	}
	.info-container {
		position: absolute;
		display: flex;
		flex-direction: row;
		gap: 10px;
		left: 18%;
		top: 25%;
	}
	// .info-container {
	// 	flex-direction: column;
	// 	gap: 1em;
	// 	height: 70%;
	// 	justify-content: center;
	// 	padding: 1em 5.5em;
	// 	border: 2px solid #eee;
	// 	border-radius: 8px;
	// 	background-color: rgba(#eee, 0.75);
	// 	box-shadow: 0 0 10px rgba(black, 0.75);
	// 	& :global(.op-text) {
	// 		text-align: center;
	// 	}
	// }
</style>
